<child-header title="Confirm Software Subscription Purchase" (closeEvent)="onNoClick()"></child-header>
<div mat-dialog-content>
  <p>
    Order total is &nbsp;
    <span
      class="color-red bold">{{data.totalSoftwareSubscriptionPendingPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</span>&nbsp;&nbsp;
  </p>

    <mat-form-field>
      <input matInput numberLettersOnly type="text" (input)="commonService.subscription_customer_ref_validation($event)" maxlength="30" class="poReference" [(ngModel)]="softwareSubscriptionPoReference" placeholder="PO REFERENCE" />
    </mat-form-field>

    <mat-checkbox [(ngModel)]="confirmChecked">
      Partner attestation *
    </mat-checkbox>
    <div class="confirm-label" (click)="checkConfirmBox()">
      <label>
        I confirm that my organization is acting as an Indirect Partner when choosing a Reseller and as a Direct Partner in the absence of selecting a reseller.<br/>
        I confirm that I am not reselling products purchased within this order to other partners that are affiliated with my parent organization
      </label>
    </div>

  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-large continue" [disabled]="!confirmChecked" (click)="continueSaveSoftware()">Continue</button>
  </div>
